"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAggregationLookup = void 0;
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _gridAggregationUtils = require("./gridAggregationUtils");
var getAggregationCellValue = function getAggregationCellValue(_ref) {
  var apiRef = _ref.apiRef,
    field = _ref.field,
    rowIds = _ref.rowIds,
    aggregationFunction = _ref.aggregationFunction;
  var values = [];
  rowIds.forEach(function (rowId) {
    var column = apiRef.current.getColumn(field);
    var cellValue = apiRef.current.getCellValue(rowId, field);
    values.push(typeof column.getValue === 'function' ? column.getValue(cellValue) : cellValue);
  });
  return aggregationFunction({
    values: values,
    field: field // Added per user request in https://github.com/mui/mui-x/issues/6995#issuecomment-1327423455
  });
};
var getGroupAggregatedValue = function getGroupAggregatedValue(_ref2) {
  var apiRef = _ref2.apiRef,
    rowIds = _ref2.rowIds,
    aggregatedFields = _ref2.aggregatedFields,
    aggregationRules = _ref2.aggregationRules;
  var groupAggregationLookup = {};
  for (var j = 0; j < aggregatedFields.length; j += 1) {
    var aggregatedField = aggregatedFields[j];
    var aggregationFunction = aggregationRules[aggregatedField];
    groupAggregationLookup[aggregatedField] = getAggregationCellValue({
      apiRef: apiRef,
      rowIds: rowIds,
      field: aggregatedField,
      aggregationFunction: aggregationFunction
    });
  }
  return groupAggregationLookup;
};
var createAggregationLookup = exports.createAggregationLookup = function createAggregationLookup(_ref3) {
  var apiRef = _ref3.apiRef,
    aggregationModel = _ref3.aggregationModel;
  var aggregationRules = (0, _gridAggregationUtils.getAggregationRules)({
    columnsLookup: (0, _xDataGridPro.gridColumnLookupSelector)(apiRef),
    aggregationModel: aggregationModel
  });
  var aggregatedFields = Object.keys(aggregationRules);
  if (aggregatedFields.length === 0) {
    return {};
  }
  var aggregationLookup = {};
  var rowTree = (0, _xDataGridPro.gridRowTreeSelector)(apiRef);
  var _createGroupAggregationLookup = function createGroupAggregationLookup(groupNode) {
    var hasChildGroup = false;
    for (var i = 0; i < groupNode.children.length; i += 1) {
      var childId = groupNode.children[i];
      var childNode = rowTree[childId];
      if (childNode.type === 'group') {
        _createGroupAggregationLookup(childNode);
        hasChildGroup = true;
      }
    }
    var hasAggregableChildren = groupNode.children.length;
    if (hasAggregableChildren && !hasChildGroup) {
      aggregationLookup[groupNode.id] = getGroupAggregatedValue({
        rowIds: filterTotals(groupNode.children),
        apiRef: apiRef,
        aggregatedFields: aggregatedFields,
        aggregationRules: aggregationRules
      });
    }
  };
  _createGroupAggregationLookup(rowTree[_xDataGridPro.GRID_ROOT_GROUP_ID]);
  return aggregationLookup;
};
var TOTALS_ID_KEY = ':Totals';
function filterTotals() {
  var rowIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return rowIds.filter(function (id) {
    return !"".concat(id).includes(TOTALS_ID_KEY);
  });
}